module.exports = "//public.zight.com/packs/media/images/icons-rounded-corners-b9a336d79e69f7907c58dc7b2e36980d.svg";